import Background from "../kevin/Background";
import ColorBack from "../kevin/ColorBack";
import Intro from "../kevin/Intro";

export default function Home(props) {
  return (
    <div>
      <ColorBack />
      <Background />
      <Intro />
    </div>
  );
}
